import { Col, Row } from 'react-bootstrap'
import ReactSlider from 'react-slider'

import { ReactComponent as AnswerNil } from '../../assets/images/answer--1.svg'
import { ReactComponent as Answer0 } from '../../assets/images/answer-0.svg'
import { ReactComponent as Answer1 } from '../../assets/images/answer-1.svg'
import { ReactComponent as Answer2 } from '../../assets/images/answer-2.svg'
import { ReactComponent as Answer3 } from '../../assets/images/answer-3.svg'
import { ReactComponent as Answer4 } from '../../assets/images/answer-4.svg'

const emojiThumbList = [
  <Answer0 />,
  <Answer1 />,
  <Answer2 />,
  <Answer3 />,
  <Answer4 />
]

export default function Question ({ setValue, userCheckin, index }) {

  const value = userCheckin.value === -1 ? 0 : userCheckin.value

  return (
    <div className='my-goals__question mb-4'>
      <Row className='mb-2'>
        <Col className='my-goals__questions__question'>
          <p className='mb-0'><span>{index}.</span> {userCheckin.measure_name}</p>
        </Col>
      </Row>

      <Row className='mb-5'>
        <Col xs={12}>
          <ReactSlider
            className='my-goals__slider'
            trackClassName={`slider-track bg-${userCheckin.value}`}
            thumbClassName='slider-thumb'
            renderThumb={(props, state) => (
              <div { ...props }>
                {userCheckin.value === -1
                  ? <AnswerNil />
                  : emojiThumbList[state.valueNow]
                }
              </div>
            )}
            min={0}
            max={4}
            value={value}
            onChange={(val) => {
              const updatedUserCheckin = {
                ...userCheckin,
                value: val
              }
              setValue(updatedUserCheckin)
            }}
          />
        </Col>
      </Row>

    </div>
  )
}
